export enum BazaDeviceTokenType {
    Apple = 'Apple',
    FCM = 'FCM',
}
